import { useLocale } from '@b2c/hooks';
import { Footer } from '@b2c/ui';
import classNames from 'classnames';
import { PropsWithChildren, useMemo } from 'react';
import { LayoutHeader } from './layout-header';
import styles from './layout.module.less';

export function Layout({
  theme,
  children,
}: PropsWithChildren<{ theme?: 'white' }>) {
  const t = useLocale();
  const layoutModifier = useMemo(() => {
    return {
      white: styles.theme_white,
    }[theme];
  }, [theme]);

  return (
    <div className={classNames(styles.layout, layoutModifier)}>
      <div className={styles.layoutBody}>
        {/* <div className={styles.layoutContainer}>
          <LayoutHeader></LayoutHeader>
        </div> */}
        <div className={styles.layoutContainer}>{children}</div>
      </div>
      <div className={styles.layoutFooter}>
        <div className={styles.layoutContainer}>
          <Footer brandName="AIGoHotel" WebSiteName="aigohotel.com"></Footer>
        </div>
      </div>
    </div>
  );
}
